import React from 'react';

import { getReactiveDetailRegistryEntry } from '../reactive-detail-shell/reactive-detail-registry';
import { platformEntityTypeForKey } from './platform-entity-type-by-key';
import { PlatformObjectBadge } from './platform-object-badge.component';

export interface PlatformObjectBadgeMapperProps {
    id: string;
    /** Field key (e.g. `spot_id`, `user_id`) — same as legacy ObjectBadgeMapper. */
    type: string;
    className?: string;
    disableClick?: boolean;
    clearable?: {
        onClear: () => void;
    };
}

/**
 * Platform counterpart of ObjectBadgeMapper: maps a field key to PlatformObjectBadge.
 * Non-registry entity types render display-only (no empty detail pane).
 */
export const PlatformObjectBadgeMapper = (props: PlatformObjectBadgeMapperProps) => {
    const entityType = platformEntityTypeForKey(props.type);
    if (!entityType) {
        return null;
    }

    const canOpenDetail = Boolean(getReactiveDetailRegistryEntry(entityType));

    return (
        <PlatformObjectBadge
            id={props.id}
            entityType={entityType}
            className={props.className}
            disableClick={props.disableClick || !canOpenDetail}
            clearable={props.clearable}
        />
    );
};
